import styled from "styled-components";
import backgroundPikachu from "../../Assets/home-background.jpg";

export const HomeStyle = styled.div`
  background-image: url(${backgroundPikachu});
  background-attachment: fixed;
  background-size: cover;
  /* background: linear-gradient(315deg, #ffdd00 20%, #fbb034 90%); */
  background-position: bottom;
  background-repeat: no-repeat;
  /* margin-bottom: -5vh; */
  /* height: 90vh; */
  /* 
  width: 100vw; */
`;
